import { PillMessage } from 'components/artwork/PillMessage'
import { Popover } from 'components/common/Popover'
import useTranslation from 'next-translate/useTranslation'
import { PropsWithChildren } from 'react'

type Props = {
  messageToShow: string
} & PropsWithChildren

export const PopularityMessage = ({ messageToShow, children }: Props) => {
  const { t } = useTranslation()

  if (!messageToShow) return null

  return (
    <>
      {messageToShow === 'nearly-gone' && (
        <Popover content={t('single_artwork:nearly_gone_tooltip')} side='top'>
          <PillMessage variant='yellow' className='lg:hidden'>
            {children}
          </PillMessage>
        </Popover>
      )}

      {messageToShow === 'trending' && (
        <Popover content={t('single_artwork:trending_tooltip')} side='top'>
          <PillMessage variant='yellow'>{children}</PillMessage>
        </Popover>
      )}
    </>
  )
}
